import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

/**
 * HrSchemaPlugin
 */
export class HrSchemaPlugin extends SchemaPlugin {
  nodes = {
    horizontal_rule: {
      group: 'block',
      parseDOM: [{ tag: 'hr' }],
      toDOM(node) { return nodeToDOM(node) },
      tagName: 'hr',
      isVoid: true
    }
  } satisfies Record<string, NodeSpec>;
}
